var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll4 = function SvgScroll4(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_4_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 217",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient",
    cx: -11.1752,
    cy: 47.5209,
    r: 244.2377,
    gradientTransform: "translate(-6.6028 -1.6544) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ceaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    stopColor: "#23afad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#6476a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5fa7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-2",
    cx: -26.7143,
    cy: 125.7305,
    r: 183.1557,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-3",
    cx: 22.6577,
    cy: 77.4151,
    r: 184.7842,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-4",
    cx: -23.63,
    cy: 79.3516,
    r: 240.3012,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-5",
    cx: -9.4396,
    cy: 74.5456,
    r: 275.2232,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-6",
    cx: -63.021,
    cy: 27.9005,
    r: 393.9144,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-7",
    cx: -36.5538,
    cy: -44.7544,
    r: 341.0425,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#scroll_4_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-8",
    cx: 31.8332,
    cy: 78.729,
    r: 134.5754,
    gradientTransform: "translate(-6.6028 -1.6544) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1848,
    stopColor: "#17c9b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    stopColor: "#58d9ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71dfa9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-9",
    cx: 115.4467,
    cy: 134.2551,
    r: 138.7992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04c0c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#2ad4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e2ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-10",
    cx: 122.2158,
    cy: 114.6869,
    r: 194.5211,
    gradientTransform: "translate(-6.6028 -1.6544) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-11",
    cx: 50.4313,
    cy: 117.0769,
    r: 118.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cd3b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2731,
    stopColor: "#68d4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    stopColor: "#5cd5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8274,
    stopColor: "#48d8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37dabc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-12",
    cx: 90.8354,
    cy: 92.7435,
    r: 159.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6760ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_4_svg__radial-gradient-13",
    cx: 97.9972,
    cy: 37.4271,
    r: 167.811,
    gradientTransform: "translate(-6.6028 -1.6544) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c3be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbabf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72aac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8e94c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e88c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_4_svg__right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_4_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,0a386.8559,386.8559,0,0,1-7,59c-1.4722,7.4749-2.7419,13.7846-6,26L.7071,157.3338,59,174l37.2444,28.196,38.5088,14.7334q-10.1172-48.6918-20.2345-97.3836Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scroll_4_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,180,97,203l38,14Q122.5,198.5,110,180Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,151,59,174l38,29,13-23Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,133,0,157l59,17,16-23Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,60,20,84Q10,120.5,0,157l39-24Q46,96.5,53,60Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,41,24,61q-2,11.5-4,23L52,60Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,0,24,61,52,41Q42.5,20.5,33,0Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-7)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_4_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,60q-8.5,36-17,72l8,2,65-12,6-2L98,101Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,40q.5,10,1,20l62,60L62,50Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,0q9.5,20.5,19,41,61.362,80.2008,63,79Q116.9641,118.559,33,0Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,120l-3,4L78,150l-3,1L36,132Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,120,75,151l35,29,3-10q1-22,2-44Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,120q-2.5,30-5,60l25,35Q125,167.5,115,120Z",
    style: {
      fill: "url(#scroll_4_svg__radial-gradient-13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "scroll_4_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,120q12.1554,57.9726,12,58-.15.0319-12-55l-3,30q1-16,2-32L89,140l24-20L99,105l12.0964,11.34Q113.0482,118.17,115,120Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_4.755a1ad8fc14d99d1456f495001c40f4.svg";